import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import Moment from 'react-moment';
import { Table } from 'reactstrap';
import { object, bool } from 'prop-types';
import DateTime from '../../../../components/DateTime/DateTime';
import { createMarkup } from '../../../../utils/utils';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { STATIC_PATH } from '../../../../config';
import Icon from '../../../../components/Icon/Icon';

class NewsListItem extends PureComponent {
  static propTypes = {
    news: object.isRequired,
    groupByDate: bool,
    inOffer: bool,
  };

  static defaultProps = {
    news: {},
    changeDate: false,
  };

  renderNewsText = ({ news, offerId, offerTitle }) => {
    return (
      <div className="news-text">
        <span dangerouslySetInnerHTML={createMarkup(news.text)} />
        {offerId && (
          <span>
            <Link to={`/offers/${offerId}/`}>{offerTitle}</Link>
          </span>
        )}
      </div>
    );
  };

  getPossibleOfferLink = (news) => {
    const regExpOffer = /<a[^>]+href=['"]?[^'" ]*?\/offers\/(\d+)[^'" ]*?[^>]*>(.*?)<\/a>/gi;
    const preparedNews = { ...news };
    const match = regExpOffer.exec(preparedNews.text);
    let text;
    let offerId;
    let offerTitle;
    if (match && match[0] && match[1] && match[2]) {
      text = preparedNews.text.replace(match[0], '');
      offerId = match[1];
      offerTitle = match[2];
    }
    return {
      news: {
        ...preparedNews,
        text: match ? text : preparedNews.text,
      },
      offerId,
      offerTitle,
    };
  };

  getIconType = (type = 0) => {
    switch (type) {
      case 0:
      case 3:
      case 4:
      case 5:
      case 8:
      case 9:
      case 10:
      case 11:
      case 12:
        return 'refresh';
      case 2:
      case 6:
        return 'pause-offer';
      case 1:
        return 'new-offer';
      case 7:
        return 'boost';
      default:
        return 'refresh';
    }
  };

  getIconColor = (type = 0) => {
    switch (type) {
      // case 0:
      // case 7:
      //   return 'purple';
      // case 1:
      // case 3:
      //   return 'blue';
      // case 2:
      //   return 'dark-orange';
      // case 4:
      // case 5:
      //   return 'light-blue';
      // case 6:
      // case 10:
      //   return 'gray';
      // case 8:
      // case 9:
      // case 12:
      //   return 'green';
      // case 11:
      //   return 'orange';
      case 1:
        return 'green';

      case 7:
        return 'blue';
      case 0:
      case 3:
      case 4:
      case 5:
      case 8:
      case 9:
      case 10:
      case 11:
      case 12:
        return 'light-green';
      case 2:
      case 6:
        return 'orange';
      default:
        return 'light-green';
    }
  };

  render() {
    const { groupByDate, inOffer } = this.props;
    const { news, offerId, offerTitle } = this.getPossibleOfferLink(this.props.news);

    return (
      <div className="news-item">
        <Table>
          <tbody>
            <tr>
              <td className={`news-icon ${this.getIconColor(news.type)}`}>
                <Link to={`/news/${news.id}`}>
                  <img src={`${STATIC_PATH}/img/news-icons/${this.getIconType(news.type)}.svg`} />
                </Link>
              </td>
              <td className="news-item-wrapper">
                <div className="news-info-wrapper">
                  <div className="news-title">
                    <b>
                      <Link to={`/news/${news.id}`}>{news.title}</Link>
                    </b>
                  </div>
                  <div>
                    <DateTime className="news-date" timestamp={news.its} withDateTime />
                  </div>
                  {this.renderNewsText({ news, offerId, offerTitle })}
                </div>
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }
}

export default NewsListItem;
